import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneMaskDirective } from '../../directives/phone-mask/phone-mask.directive';
// import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [PhoneMaskDirective],
  imports: [CommonModule /*, ReactiveFormsModule*/],
  exports: [PhoneMaskDirective],
})
export class SharedModule {}
